import { mapActions } from 'vuex'

export default {
  ...mapActions(['setupJWT', 'updateUserData', 'updateSettings']),
  doLogin () {
    this.$v.$touch()
    if (this.$v.$error) {
      return
    }

    this.$resource
      .post('', this.credentials)
      .then(({ data }) => {
        const token = data.token
        Promise.all([
          this.updateUserData(data.user),
          // desabilitando verificar depois
          // - this.updateSettings(data.user.settings),
          this.setupJWT(token)
        ]).then(() => {
          return this.$router.push({ name: 'dashboard' })
        })
      })
      .catch(({meta}) => {
        this.loginFail = meta.message
      })
  },
  goToLoadingPage () {
    location.href = this.URL_LOADING_PAGE_PATIENT
  },
  remenberMe (remenber) {
    if (remenber) {
      this.credentials.remember = false
      localStorage.removeItem('remember-dweller')
    } else {
      const isRemberMe = {remember: this.credentials.remember, email: this.credentials.email}
      localStorage.setItem('remember-dweller', JSON.stringify(isRemberMe))
      this.credentials.remember = true
    }
  },
  isRemenberActive () {
    if (localStorage.getItem('remember-dweller') === null) {
      return
    }
    const existRemenber = JSON.parse(localStorage.getItem('remember-dweller'))
    this.credentials = {
      type: 'dweller',
      email: existRemenber.email,
      remember: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/login/dweller/resources/methods.js